import {Injectable} from '@angular/core';
import {HttpResponse} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class FileDownloadService {
  public downloadFromResponse(response: HttpResponse<Blob>): void {
    if (!response.body) return;

    const filename = this.getFilenameFromResponse(response);
    const url = window.URL.createObjectURL(response.body);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  }

  private getFilenameFromResponse(response: HttpResponse<Blob>): string {
    const disposition = response.headers.get('content-disposition');
    if (!disposition) return 'document';

    const match = disposition.match(/filename="?([^"]+)"?/);
    return match ? match[1] : 'document';
  }
}
